import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export const Container = styled(Link)`
  display: flex;
  flex-direction: row;
  height: 34px;
  align-items: center;
  text-decoration: none;
`;

export const IndicatorNub = styled.div<{ isCurrent: boolean }>`
  visibility: ${(props) => (props.isCurrent ? "visible" : "hidden")};
  background: linear-gradient(
    180deg,
    rgba(64, 117, 255, 1) 0%,
    rgba(60, 113, 251, 1) 100%
  );
  border: 1px solid rgba(0, 92, 214, 0.01);
  box-shadow: inset -2px 0px 0px -1.1px rgba(255, 255, 255, 0.2);
  border-radius: 120px;
  height: 8px;
  margin-left: -9px;
  width: 11px;
`;

export const Content = styled.div<{ isCurrent: boolean; isCollapsed: boolean }>`
  background-color: ${(props) =>
    props.isCurrent ? BLUE_LIGHT : "transparent"};
  box-sizing: border-box;
  color: ${(props) => (props.isCurrent ? OLD_BLUE : "rgba(74, 84, 102, 1)")};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  height: 30px;
  margin: ${({ isCollapsed }) => (isCollapsed ? "0px 8px" : "0px 30px")};
  padding: 8px 0px;
  position: relative;
  transition: background-color 0.25s ease;
  width: ${({ isCollapsed }) => (isCollapsed ? "48px" : "calc(100% - 60px)")};
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? "center" : "flex-start"};
  gap: ${({ isCollapsed }) => (isCollapsed ? "0" : "16px")};
  border-radius: ${({ isCollapsed }) => (isCollapsed ? "8px" : "0")};
  z-index: 1;

  &:hover {
    background-color: ${(props) =>
      props.isCurrent ? BLUE_LIGHT : "rgba(235, 238, 243, 1)"};
    &::before,
    &::after {
      background-color: ${(props) =>
        props.isCurrent ? BLUE_LIGHT : "rgba(235, 238, 243, 1)"};
    }
  }

  &::before,
  &::after {
    background-color: ${(props) =>
      props.isCurrent ? BLUE_LIGHT : "transparent"};
    content: "";
    display: ${({ isCollapsed }) => (isCollapsed ? "none" : "block")};
    height: 30px;
    position: absolute;
    top: 0px;
    transition: background-color 0.25s ease;
    width: 30px;
    z-index: -1;
  }

  &::before {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    left: -30px;
    margin-left: 15px;
  }

  &::after {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    right: -30px;
    margin-right: 15px;
  }
`;

export const IconWrapper = styled.div`
  height: 18px;
  width: 18px;
`;

export const Title = styled.div<{ isCollapsed: boolean }>`
  font-size: 14px;
  display: ${({ isCollapsed }) => (isCollapsed ? "none" : "block")};
`;
